import { Loader2, Receipt, Plus } from "lucide-react";
import POSHeader from "@/components/pos/POSHeader";
import useContaMesa from "@/components/pos/ContaMesaView/useContaMesa";
import OrderItemsList from "@/components/pos/ContaMesaView/OrderItemsList";
import PaymentActionsBar from "@/components/pos/ContaMesaView/PaymentActionsBar";
import PaymentSuccessView from "@/components/pos/ContaMesaView/PaymentSuccessView";
import PaymentModal from "@/components/pos/ContaMesaView/PaymentModal";
import CashPaymentModal from "@/components/pos/ContaMesaView/CashPaymentModal";
import SplitBillModal from "@/components/pos/ContaMesaView/SplitBillModal";
import MultiPaymentModal from "@/components/pos/ContaMesaView/MultiPaymentModal";

export default function ContaMesaView({ authAxios, table, onBack, onAddMore }) {
  const {
    loading,
    account,
    allItems,
    total,
    change,
    multiPayments,
    newPaymentMethod,
    setNewPaymentMethod,
    newPaymentAmount,
    setNewPaymentAmount,
    totalPaid,
    remaining,
    splitParts,
    setSplitParts,
    splitType,
    setSplitType,
    cashReceived,
    setCashReceived,
    processing,
    paymentSuccess,
    paidTotal,
    paidChange,
    showPaymentModal,
    setShowPaymentModal,
    showSplitModal,
    setShowSplitModal,
    showCashModal,
    setShowCashModal,
    showMultiPayModal,
    setShowMultiPayModal,
    handlePayment,
    handleMultiPaymentConfirm,
    addMultiPayment,
    removeMultiPayment,
    handleSplitBill,
    handleCloseTable,
    handleUpdateItemQuantity,
    handleRemoveItem,
  } = useContaMesa({ authAxios, table, onBack });

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex flex-col" data-testid="pos-conta-mesa">
      <POSHeader
        title={table.name || `Mesa ${table.number}`}
        icon={Receipt}
        onBack={onBack}
        rightContent={
          <button
            onClick={onAddMore}
            className="h-8 px-3 rounded-lg bg-white/20 flex items-center gap-1 text-[10px] font-bold"
          >
            <Plus className="w-3 h-3" /> ADICIONAR
          </button>
        }
      />

      {paymentSuccess ? (
        <PaymentSuccessView
          paidTotal={paidTotal}
          paidChange={paidChange}
          onCloseTable={handleCloseTable}
          onBack={onBack}
        />
      ) : loading ? (
        <div className="flex-1 flex items-center justify-center">
          <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
        </div>
      ) : (
        <>
          <div className="flex-1 overflow-y-auto overscroll-contain bg-white">
            <OrderItemsList
              allItems={allItems}
              onUpdateQuantity={handleUpdateItemQuantity}
              onRemoveItem={handleRemoveItem}
            />
          </div>

          <PaymentActionsBar
            total={total}
            account={account}
            onPay={() => setShowPaymentModal(true)}
            onMultiPay={() => {
              setShowMultiPayModal(true);
            }}
            onSplit={() => setShowSplitModal(true)}
            onAddMore={onAddMore}
            onCloseTable={handleCloseTable}
          />
        </>
      )}

      <PaymentModal
        open={showPaymentModal}
        onOpenChange={setShowPaymentModal}
        total={total}
        processing={processing}
        onSelectCash={() => {
          setShowPaymentModal(false);
          setShowCashModal(true);
          setCashReceived("");
        }}
        onPayCard={() => handlePayment("card")}
        onPayBizum={() => handlePayment("bizum")}
        onPayMbway={() => handlePayment("mbway")}
      />

      <CashPaymentModal
        open={showCashModal}
        onOpenChange={setShowCashModal}
        total={total}
        cashReceived={cashReceived}
        onCashReceivedChange={setCashReceived}
        change={change}
        processing={processing}
        onConfirm={() => handlePayment("cash", parseFloat(cashReceived) || total)}
      />

      <SplitBillModal
        open={showSplitModal}
        onOpenChange={setShowSplitModal}
        total={total}
        splitParts={splitParts}
        setSplitParts={setSplitParts}
        splitType={splitType}
        setSplitType={setSplitType}
        onSplitBill={handleSplitBill}
        onManualSplit={() => {
          setSplitType("manual");
          setShowMultiPayModal(true);
          setShowSplitModal(false);
        }}
      />

      <MultiPaymentModal
        open={showMultiPayModal}
        onOpenChange={setShowMultiPayModal}
        total={total}
        totalPaid={totalPaid}
        remaining={remaining}
        multiPayments={multiPayments}
        newPaymentMethod={newPaymentMethod}
        setNewPaymentMethod={setNewPaymentMethod}
        newPaymentAmount={newPaymentAmount}
        setNewPaymentAmount={setNewPaymentAmount}
        onAddPayment={addMultiPayment}
        onRemovePayment={removeMultiPayment}
        onConfirm={handleMultiPaymentConfirm}
        processing={processing}
      />
    </div>
  );
}
